class ChakrikkaMobileDrawer extends HTMLElement {
  constructor() {
    super();

    var overlay = this.querySelector('[data-mobile-menu-overlay]');
    if (overlay) overlay.addEventListener('click', this.close.bind(this));

    var closeBtn = this.querySelector('[data-close-mobile-menu]');
    if (closeBtn) closeBtn.addEventListener('click', this.close.bind(this));

    this.querySelectorAll('.chakrikka-mobile-menu__panel a').forEach((link) => {
      link.addEventListener('click', () => this.close());
    });
  }

  open(triggeredBy) {
    if (triggeredBy) {
      this.activeElement = triggeredBy;
      triggeredBy.setAttribute('aria-expanded', 'true');
    }

    setTimeout(() => {
      this.classList.add('active');
    });

    this.addEventListener(
      'transitionend',
      (event) => {
        if (event.propertyName !== 'transform') return;
        var inner = this.querySelector('.drawer__inner');
        var focusElement = this.querySelector('[data-close-mobile-menu]') || inner;
        trapFocus(inner, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    if (!this.classList.contains('active')) return;

    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');

    var trigger = document.querySelector('[data-mobile-menu-trigger]');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  }
}

customElements.define('chakrikka-mobile-drawer', ChakrikkaMobileDrawer);
